module.exports = __webpack_public_path__ + "static/media/features-split-image-04.d1dc5e1b.svg";